import React, { useState, useContext, useEffect } from "react";
import { Button, Input, Typography, Modal, Spin, Switch, Tooltip, Select } from "antd"; // Import Spin for loading indicator
import { TeamOutlined, PlusOutlined, LoadingOutlined } from "@ant-design/icons"; // Import LoadingOutlined
import { SketchPicker } from "react-color"; // 🎨 Color Picker
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/authContext";
import axios from "axios";
import { unloadUnityWebGL, unityContext } from "../context/unityContext";
import Messages from '../components/Messages';
const { Title, Text } = Typography;

const Classes = () => {
  const { currentUser } = useContext(AuthContext);
  const { showMessageError, showMessageWarning, showMessageInfo, showMessageSuccess, messageHolder } = Messages();

  const [isOwner, setIsOwner] = useState(false);
  const [allMembers, setMembers] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [isMember, setIsMember] = useState(false);
  const [className, setClassName] = useState("");
  const [classes, setClasses] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedColor, setSelectedColor] = useState("#FFD700"); // Default yellow color
  const [loading, setLoading] = useState(true); // Loading state
  const navigate = useNavigate();

  useEffect(() => {

    if (unityContext) unloadUnityWebGL();
    const fetchClasses = async () => {
      setLoading(true);
      try {
        let response;
        console.log("currentUser.id:", currentUser);
        if (currentUser.role === 0) {
          // Admin fetches owned classes
          setIsOwner(true);
          console.log("admin get class");
          // response = await axios.get(`/api/classes/${currentUser.id}`);
          response = await axios.get(`/api/classes`);
        } else if (currentUser) {
          // Normal users fetch classes they belong to
          console.log("normal user get class");
          // response = await axios.get(`/api/classes/${currentUser.id}`);
        }
        setClasses(response.data);
      } catch (error) {
        console.error("Error fetching classes:", error);
        showMessageError("Beim Abrufen der Klassen ist ein Fehler aufgetreten.");
      } finally {
        setLoading(false);
      }
    };
    if (currentUser && currentUser.id) {
      fetchClasses();
    }

  }, [currentUser.id, currentUser.role]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => {
    setClassName("");
    setSelectedColor("#FFD700"); // Reset to default color
    setIsModalOpen(false);
  };

  const handleClassSubmit = async () => {
    if (!className.trim()) {
      showMessageError("Bitte trage einen gültigen Klassennamen ein.");
      return;
    }

    try {
      console.log("Creating class with members:", selectedMembers);
      const response = await axios.post("/api/classes", {
        title: className,
        color: selectedColor, // Send the selected color 🎨
        // created_at: new Date(),
        owner_id: currentUser.id,
        selected_members: selectedMembers
      });

      const newClass = response.data;

      showMessageSuccess(
        `Die Klasse "${newClass.title}" wurde erfolgreich erstellt!`
      );
      setIsMember(true);
      setClasses([...classes, newClass]);
      setClassName("");
      setSelectedColor("#FFD700");
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error creating class:", error);
      showMessageError("Beim Erstellen der Klasse ist ein Fehler aufgetreten.");
    }
  };

  // Custom loading indicator
  const loadingIndicator = (
    <LoadingOutlined style={{ fontSize: 24, color: "#FFD700" }} spin />
  );

  const [canControlDMC, setCanControlDMC] = useState({});

  useEffect(() => {
    const fetchProjectionPermissions = async () => {
      try {
        const response = await axios.get("/api/classes/dmc"); // Fetch all classes
        const permissions = {};

        response.data.forEach((classItem) => {
          permissions[classItem.id] = classItem.can_control_dmc === 1; // Ensure it's a boolean
        });

        setCanControlDMC(permissions); // Update state with all permissions
      } catch (error) {
        console.error("Error fetching projection permissions:", error);
      }
    };

    if (classes.length > 0) {
      fetchProjectionPermissions();
    }
  }, [classes]);

  // const handleCanControlDMCToggle = async (classId, canControl) => {
  //   try {
  //     const url = canControl
  //       ? `/api/classes/${classId}/grant-dmc`
  //       : `/api/classes/${classId}/revoke-dmc`;

  //     await axios.put(url); // Update permission in DB

  //     // Update local state to reflect the change immediately
  //     setCanControlDMC((prev) => ({
  //       ...prev,
  //       [classId]: canControl,
  //     }));

  //     showMessageSuccess(
  //       canControl
  //         ? "Die Klasse kann nun die Medien steuern."
  //         : "Die Klasse kann die Medien nicht mehr steuern."
  //     );
  //   } catch (error) {
  //     console.error("Error updating projection permission:", error);
  //     showMessageError("Fehler beim Aktualisieren der Berechtigungen.");
  //   }
  // };
  // Filter characters to exclude those that already have a task of the selected type
  const getAvailableMembers = () => {
    // if (!taskType) return characters;

    // Convert character_ids from CSV string to an array
    const membersWithTask = new Set(
      allMembers
        .filter((member) => member.role === 0)
        .flatMap((task) =>
          task.character_ids ? task.character_ids.split(",").map(Number) : []
        )
    );

    // console.log(
    //   "Filtered Available Members:",
    //   allMembers.filter((member) => !membersWithTask.has(member.id))
    // );

    return allMembers.filter(
      (member) => !membersWithTask.has(Number(member.id))
    );
  };
  useEffect(() => {
    const fetchMembers = async () => {
      // TODO: // update this function to only fetch users in the group
      try {
        const response = await axios.get("/api/users"); // Fetch all users
        // console.log("Fetched Members:", response);

        setMembers(response.data.filter(user => user.role !== 0)); // Exclude admins from members list
      } catch (error) {
        console.error("Error fetching members:", error);
        showMessageError("Fehler beim Abrufen der Benutzer.");
      }
    };
    fetchMembers();
  }, []);
  
  return (
    <div style={{ padding: "24px", textAlign: "left" }}>
      {/* Title Section */}
      <Title level={2}>Klassen</Title>
      <h1>{isOwner}</h1>
      {/* Show "Create Class" button only for admins */}
      {isOwner && (
        <Button
          type="primary"
          size="large" className="btn"
          icon={<PlusOutlined style={{ fontSize: '24px' }} />}
          onClick={handleOpenModal}
          style={{ marginBottom: "16px" }}
        >
          Neue Klasse erstellen
        </Button>

      )}

      {loading ? (
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <Spin indicator={loadingIndicator} size="large" />
        </div>
      ) : (
        <>
          {/* No Classes Message */}
          {classes.length === 0 && (
            <div style={{ textAlign: "left", marginTop: "40px" }}>
              <TeamOutlined
                style={{
                  fontSize: "64px",
                  color: "#FFD700",
                  display: "block",
                  marginBottom: "8px",
                }}
              />
              <Text style={{ fontSize: "16px", color: "#666" }}>
                {isOwner
                  ? "Du hast noch keine Klasse erstellt."
                  : "Du bist noch kein Mitglied einer Klasse."}
              </Text>
            </div>
          )}

          {/* Classes List */}
          {classes.length > 0 && (
            <div style={{ marginTop: "16px" }}>
              {classes.map((classItem, index) => (
                <div
                  key={classItem.id}
                  onClick={() => navigate(`/class/${classItem.id}`)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f5f5f5",

                    borderRadius: "8px",
                    marginBottom: "8px",
                    cursor: "pointer",
                    transition: "background 0.3s",
                    border: `1px solid ${classItem.color || "#ddd"}`,
                  }}
                >
                  {/* Colored Square with Number */}
                  <div
                    style={{
                      width: "60px",
                      height: "100px",
                      backgroundColor: classItem.color || "#FFD700",
                      color: "#fff",
                      fontSize: "18px",
                      fontWeight: "bold",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "6px",
                      marginRight: "12px",
                    }}
                  >
                    {index + 1}
                  </div>

                  {/* Class Name */}
                  <Text style={{ fontSize: "16px", fontWeight: "500" }}>
                    {classItem.title}
                  </Text>

                  {/* Projection Control Toggle (Admins Only) */}
                  {isOwner && (
                    <div
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        marginLeft: "auto",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >

                      {/* <Tooltip title="Erlaubt dieser Klasse die Mediensteuerung">

                        <Switch
                          checkedChildren="Mediensteuerung erlaubt" unCheckedChildren="Mediensteuerung deaktiviert"
                          checked={canControlDMC[classItem.id] || false}
                          onChange={(checked) => handleCanControlDMCToggle(classItem.id, checked)}
                        />
                      </Tooltip> */}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* Modal for Creating Classes (Admins Only) */}
      {isOwner && (
        <Modal
          title="Bitte trage einen Klassennamen ein"
          open={isModalOpen}
          onCancel={handleCloseModal}
          footer={null}
        >
          <Input
            placeholder="Klassenname"
            value={className}
            onChange={(e) => setClassName(e.target.value)}
            style={{
              border: "2px solid #FFD700",
              borderRadius: "4px",
              marginBottom: "16px",
            }}
          />

          {/* Color Picker */}
          <div style={{ textAlign: "center", marginBottom: "16px" }}>
            <Text>Wähle eine Farbe:</Text>
            <SketchPicker
              color={selectedColor}
              onChangeComplete={(color) => setSelectedColor(color.hex)}
            />
          </div>
          <Select
            // disabled={!taskType} // Disable until task type is selected
            mode="multiple"
            placeholder="Mitglieder auswählen"
            style={{ width: "100%", marginBottom: "10px" }}
            value={selectedMembers} // Bind to selectedMembers state
            onChange={(value) => setSelectedMembers(value)} // Update state on change
          >
            {getAvailableMembers().map((char) => (
              <Select.Option key={char.id} value={char.id}>
                {char.username}
              </Select.Option>
            ))}
          </Select>
          {/* Buttons */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              type="primary"
              onClick={handleClassSubmit}
              style={{ width: "48%" }}
            >
              Erstellen
            </Button>
            <Button onClick={handleCloseModal} style={{ width: "48%" }}>
              Abbrechen
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Classes;
